import {
  css,
  DefaultTheme
} from 'styled-components';

import { FONT_MAP } from './StyledComponents';

export const globalStyleCommon = css<DefaultTheme>`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  h1 {
    font-size: 6.4rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.6rem;
  }

  /* _globals.scss */
  body {
    background-color: ${({ theme }) => theme.colorBackground};
    font-family: ${({ theme: { typography } }) => FONT_MAP[typography.bodyTypeface]};
    font-weight: 400;
    font-size: 1.6rem;
    line-height: ${({ theme }) => theme.colorLineHeight};
    color: ${({ theme: { text } }) => text.colorText};
    -webkit-font-smoothing: antialiased;
  }

  body.modal__show {
    overflow: hidden;
  }

  a {
    transition: color 100ms ease-out;
    color: ${({ theme: { link } }) => link.colorLink};
    text-decoration: ${({ theme }) => theme.globalAnchorDecoration};
    cursor: pointer;
  }

  a:hover {
    color: ${({ theme: { link } }) => link.colorLinkHover};
  }

  a:active {
    outline: none;
  }

  ${({ theme }) => css`
      ${theme.outline && css`
        a:focus, button:focus {
          outline: ${theme.outline};
        }
      `}

      ${theme.themeTwo.name !== 'legacy_partner' && css`
        a:focus, button:focus {
          outline: 0;
          box-shadow: none;
        }

        a:focus:not(:focus-visible),
        button:focus(:focus-visible) {
          outline: 0;
          box-shadow: none;
        }

        a:focus-visible,
        button:focus-visible {
          outline: ${theme.outline};
        }
      `}
    `
  }

  p {
    margin-bottom: 1em;
    font-size: 1.6rem;
    line-height: 2.2rem;
  }

  small {
    margin-bottom: 1em;
    display: block;
    font-size: 1.2rem;
    line-height: 2rem;
  }

  img {
    max-width: 100%;
  }

  ul {
    list-style-type: none;
  }

  button {
    padding: 0;
    background: transparent;
    border: none;
  }

  input,
  select {
    /* remove default background */
    appearance: none;
    box-shadow: none;
    transition: background-color 0.15s ease-out;
  }

  input[type='checkbox'] {
    appearance: checkbox;
  }
  input[type='radio'] {
    appearance: radio;
  }

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }

  .sr-hide {
    display: none;
    visibility: hidden;
  }

  .sr-only {
    width: 1px;
    height: 1px;
    position: absolute;
    top: 0;
    left: -999px;
    clip: rect(1px, 1px, 1px, 1px);
    overflow: hidden;
    white-space: nowrap;
  }

  .txt-align__center {
    text-align: center;
  }

  .txt-align__right {
    text-align: right;
  }
`;
